import { Stack, Diagram, Box, Text } from "grommet";
import React from "react";

const ProcessGraph = () => {
    return (
        <>
            <Stack guidingChild={1}>
                <Diagram
                    connections={[
                        {
                            fromTarget: "1",
                            toTarget: "2",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "2",
                            toTarget: "3",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "3",
                            toTarget: "4",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "4",
                            toTarget: "5",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                        {
                            fromTarget: "5",
                            toTarget: "6",
                            thickness: "xsmall",
                            color: "brandColor",
                            anchor: "vertical",
                        },
                    ]}
                />
                <Box align="center" justify="center">
                    <Box width={"300px"} gap="small">
                        <Box id="1" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 1: Team Registrations{" "}
                                <Text size="small" color={"brandColor"}>
                                    (24 September - 20 October)
                                </Text>
                            </Text>
                        </Box>
                        <Box id="2" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 2: Submit proof of completed HP Gaming Garage course by{" "}
                                <Text size="small" color={"brandColor"}>
                                    10 November
                                </Text>
                            </Text>
                        </Box>
                        <Box id="3" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 3: Submit Game Prototype Presentation by{" "}
                                <Text size="small" color={"brandColor"}>
                                    10 November
                                </Text>
                            </Text>
                        </Box>
                        <Box id="4" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 4: Round 1 Judging and Selection of rAge Participants by{" "}
                                <Text size="small" color={"brandColor"}>
                                    15 November
                                </Text>
                            </Text>
                        </Box>
                        <Box id="5" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 5: Announcing rAge Teams on{" "}
                                <Text size="small" color={"brandColor"}>
                                    18 November
                                </Text>
                            </Text>
                        </Box>
                        <Box id="6" round="small" margin="xsmall" pad="small" background="background-front">
                            <Text size="small">
                                Step 6: rAge Weekend (Final Judging & Prizegiving) on{" "}
                                <Text size="small" color={"brandColor"}>
                                    29 and 30 November
                                </Text>
                            </Text>
                        </Box>
                    </Box>
                </Box>
            </Stack>
        </>
    );
};

export default ProcessGraph;
